class ScarceMenuDrawer extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      this.querySelector('#MenuDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.setHeaderCartIconAccessibility();
    }
  
    setHeaderCartIconAccessibility() {
      const drawerLink = document.querySelector('#menu-drawer-open');
      drawerLink.setAttribute('role', 'button');
      drawerLink.setAttribute('aria-haspopup', 'dialog');
      drawerLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(drawerLink)
      });
      drawerLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(drawerLink);
        }
      });
    }
  
    open(triggeredBy) {
      if (triggeredBy) this.setActiveElement(triggeredBy);
      // here the animation doesn't seem to always get triggered. A timeout seem to help
      setTimeout(() => {this.classList.add('animate', 'active')});
  
      this.addEventListener('transitionend', () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('MenuDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      }, { once: true });
  
      document.body.classList.add('overflow-hidden');
    }
  
    close() {
      this.classList.remove('active');
      removeTrapFocus(this.activeElement);
      document.body.classList.remove('overflow-hidden');
    }
    setActiveElement(element) {
      this.activeElement = element;
    }
}
customElements.define('scarce-menu-drawer', ScarceMenuDrawer);

ScrollReveal().reveal('.fade-in-up', {
  distance: '50px',
  duration: 1200,
  interval: 600
});
// DISABLE stickWebsiteHeader
// const stickWebsiteHeader = () => {
//   const websiteHeader = document.querySelector('.site-masthead');
//   let lastScrollTop = 0;
  
//   window.addEventListener('scroll', function(){
//     if (document.body.getBoundingClientRect().top < -45) {
//       let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
//       if (scrollTop > lastScrollTop) {
//         websiteHeader.classList.add('h-0', 'overflow-hidden', 'p-0');
//         websiteHeader.classList.remove('py-2');
//       } else if (scrollTop < lastScrollTop) {
//         websiteHeader.classList.add('py-2');
//         websiteHeader.classList.remove('h-0', 'overflow-hidden', 'p-0');
//       }
//       lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
//     } else {
//       websiteHeader.classList.add('py-2');
//       websiteHeader.classList.remove('h-0', 'overflow-hidden', 'p-0');
//     }
//   }, false);
// }


const forceVariantSelections = () => {
  const requiredRadioGroups = document.querySelectorAll('.required-radio-group');
  const buyButtonsWrapper = document.querySelector('#buy-buttons-wrapper');
  const numChecked = {};
  
  requiredRadioGroups.forEach((group, index) => {
    const radios = group.querySelectorAll('input[type="radio"]');
    numChecked[index] = false;
  
    radios.forEach(radio => {
      radio.addEventListener('change', function(){
        if (radio.checked) {
          numChecked[index] = true;
          
          if (Object.values(numChecked).every((val) => val === true)){
            buyButtonsWrapper.classList.remove('hidden');
          }
        }
      })
    })
  })
}

const toggleMetafieldsContainer = () => {
  const metafieldsToggle = document.querySelector('#metafields-toggle');
  const metafieldsContainer = document.querySelector('#product-metafields-options');

  if (metafieldsContainer) {
    metafieldsContainer.classList.add('hidden');
  }
  
  if (metafieldsToggle) {
     metafieldsToggle.addEventListener('click', function(){
      metafieldsContainer.classList.toggle('hidden');
      metafieldsToggle.classList.toggle('showing-metafields');
    });
  }
 
}

function makeTimer(dateString) {
  //var endTime = new Date("28 October 2021 13:00:00 GMT-04:00");	
  var endTime = new Date(dateString);			
  endTime = (Date.parse(endTime) / 1000);

  var now = new Date();
  now = (Date.parse(now) / 1000);

  var timeLeft = endTime - now;

  var days = Math.floor(timeLeft / 86400); 
  var hours = Math.floor((timeLeft - (days * 86400)) / 3600);
  var minutes = Math.floor((timeLeft - (days * 86400) - (hours * 3600 )) / 60);
  var seconds = Math.floor((timeLeft - (days * 86400) - (hours * 3600) - (minutes * 60)));

  if (hours < "10") { hours = "0" + hours; }
  if (minutes < "10") { minutes = "0" + minutes; }
  if (seconds < "10") { seconds = "0" + seconds; }

  $("#days").html(days);
  $("#hours").html(hours);
  $("#minutes").html(minutes);
  $("#seconds").html(seconds);		
}

function customSubscriptions(){
  const subscriptionOptions = document.querySelectorAll('.custom-subscription-option');
  let last = null;
  
  for (let option of subscriptionOptions) {
    const radio = option.querySelector('input[type="radio"]');
    const body = option.querySelector('.custom-subscription-option__body');
    const innerHeight = body?.querySelector('.body__inner') ? body.querySelector('.body__inner').offsetHeight : 0;

    if (radio.checked === true) {
      last = option
    }
    
    option.addEventListener('click', function(){
      if (last){
        const lastBody = last.querySelector('.custom-subscription-option__body');
        last.classList.remove('option-active');

        if (lastBody){
          lastBody.style.height = 0;
        }
        
      }
      last = option;
      option.classList.add('option-active');
      if (body) {
        body.style.height = innerHeight + 32 + 'px';
      }


//       if (radio.id === 'subscription-option-null') {
//         const url = new URL(window.location.href);
//         url.searchParams.delete("selling_plan");
//         window.history.pushState(null, '', url.toString());
// console.log(url.searchParams)
//       }
    })
  }
}

// stickWebsiteHeader();

forceVariantSelections();
toggleMetafieldsContainer();
customSubscriptions();